export default __webpack_public_path__ + "static/media/medium-aquamarine.fcff95f1.png";